export const APP_BAR_HEIGHT = 65;

export const PAGES = [
  {
    name: 'Music',
    url: 'music',
  },
  {
    name: 'Shows',
    url: 'shows',
  },
  {
    name: 'Contact',
    url: 'contact',
  },
];
export const SITE_NAME = "CARL HAUCK";
